import { Routes, Route } from 'react-router-dom'
import Accounts from './index/Accounts'
import AccountForm from './form/AccountForm'
import AccountView from './show/AccountView'
import Page404 from 'views/errors/Page404'
import { useStateContext } from 'context/ContextProvider'
import { Role } from 'types'

const ClientsRoutes = () => {

  const { user } = useStateContext();

  if( ![Role.Admin,Role.Advisor,Role.Manager,Role.Accounting,Role.User].some(value => user?.roles.includes(value))){
    return <Page404 />
  }

  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={<Accounts />}
        />
        <Route
          path="new"
          element={<AccountForm key="accountCreate" />}
        />
        <Route
          path=":id"
          element={<AccountForm key="accountUpdate" />}
        />
        <Route
          path="view/:id"
          element={<AccountView key="accountView" />}
        />
      </Route>
    </Routes>
  )
}

export default ClientsRoutes
